import React, { useState, useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { validateOtpThunk, resendOtpThunk } from "../../Redux/thunks/otpThunks"; // Assuming you have a thunk for resending OTP
import { setAuthenticated, setLogin } from "../../Redux/actions/actions";
import { UniqueIdContext } from "../../FinContext";
import { verifyThunk } from "../../Redux/thunks/verifyThunks";
// import ButtonDropDown from "../../Components/buttonDropDown";
import Navigation from "../../Components/Nav/Navigation";
import ButtonDropDown from "../../Components/buttonDropDown";
import { Trans, useTranslation } from "react-i18next";
import OtpInput from "react-otp-input";
import background from "../../assets/background/background.jpg";
import NavBar from "../../Components/Nav/newNavBar";
import Footer from "../../Components/Footer/footer";
import i18next from "i18next";
import { Loader } from "lucide-react";

const OTPInput = () => {
    const { t } = useTranslation();
    const uniqueIdObject = useSelector((state) => state.uin);
    const dataID = useSelector((state) => state.verify);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoading = useSelector((state) => state.otp.isLoading);
    const isResponseError = useSelector((state) => state.otp.error);
    const data = useSelector((state) => state.otp.data);
    const verify = useSelector((state) => state.verify);
    const isAuthenticated = verify?.data === null ? false : true;
    const [otp, setOtp] = useState("");
    if ("OTPCredential" in window) {
        const ac = new AbortController();

        navigator.credentials
            .get({
                otp: { transport: ["sms"] },
                signal: ac.signal,
            })
            .then((otp) => {
                setOtp({ otp: otp.code });
                ac.abort();
            })
            .catch((err) => {
                ac.abort();
                console.log(err);
            });
    }
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
    const [error, setError] = useState(null);
    const { auth, setAuth, otpAuth, setOTPAuth } = useContext(UniqueIdContext);
    const firstInputRef = useRef(null);
    const [resendTimeout, setResendTimeout] = useState(null);
    const [resendTime, setResendTime] = useState(null);
    const timeoutDuration = 30;
    const [remainingTime, setRemainingTime] = useState(timeoutDuration);

    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
        // Disable resend for 30s when the OTP page first opens
        setResendTime(Date.now());
        setRemainingTime(timeoutDuration);
    }, []);

    useEffect(() => {
        if (isAuthenticated) {
            if (data) {
                dispatch(setAuthenticated());
                dispatch(setLogin());
                navigate("/dashboard");
            }
        } else {
            navigate("/");
        }
    }, [data, dispatch, navigate]);

    const handleChange = (element, index) => {
        const inputValue = element.value;
        if (!/^\d*$/.test(inputValue)) {
            // setError("Please enter only numbers.");
            setTimeout(() => {
                setError(null);
                element.value = "";
            }, 2000);
            return;
        }

        const newOtp = [...otp];
        newOtp[index] = inputValue;
        setOtp(newOtp);

        if (element.nextSibling && inputValue) {
            element.nextSibling.focus();
        }
    };

    const handleKeyDown = (event, index) => {
        if (event.key === "Backspace" && !otp[index]) {
            const prevInput = event.target.form.elements[index - 1];
            if (prevInput) {
                prevInput.focus();
            }
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const fullOtp = otp;
        if (fullOtp.length === 6) {
            setIsSubmitDisabled(true);
            dispatch(
                validateOtpThunk(
                    fullOtp,
                    uniqueIdObject.uin,
                    uniqueIdObject.verificationMethod
                )
            ).finally(() => setIsSubmitDisabled(false));
        }
    };

    const handleResend = () => {
        setResendTime(Date.now());
        setRemainingTime(timeoutDuration);
        dispatch(
            verifyThunk(
                uniqueIdObject?.uin,
                uniqueIdObject?.verificationMethod,
                "",
                true
            )
        );
    };

    useEffect(() => {
        if (!resendTime) return;

        const timer = setInterval(() => {
            const elapsed = Math.floor((Date.now() - resendTime) / 1000);
            if (elapsed >= timeoutDuration) {
                clearInterval(timer);
                setResendTime(null);
                setRemainingTime(timeoutDuration);
            } else {
                setRemainingTime(timeoutDuration - elapsed);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [resendTime, timeoutDuration]);

    return (
        <div className='relative md:min-h-[100dvh] overflow-hidden bg-cover bg-fin-verification'>
            <NavBar />

            <div className='relative flex flex-col overflow-y-scroll scrollbar-hide py-32 md:min-h-screen md:pb-[6%] items-center justify-center bg-cover bg-opacity-6 font-barlow px-5'>
                <form
                    onSubmit={handleSubmit}
                    autoComplete='off'
                    className='max-w-[500px] text-center shadow-lg rounded-2xl overflow-hidden'
                >
                    <div className='bg-MetallicBlue p-8 text-white flex flex-col'>
                        <p className='text-4xl font-thin'>{t("home-title1")}</p>
                        <div className='flex flex-wrap justify-center'>
                            <p className='text-3xl font-bold'>
                                {t("home-title2")}
                            </p>{" "}
                            {i18next.language === "amh" ? (
                                <>
                                    <p className='text-3xl font-bold ml-1.5'>
                                        {" " + t("home-title3")}
                                    </p>
                                    <p className='text-3xl font-bold'>
                                        {t("home-title4")}
                                    </p>
                                </>
                            ) : null}
                        </div>
                        <p 
                        className='text-sm mt-2 leading-5 text-justify mx-auto max-w-prose'
                        style={{ textAlignLast: 'center' }}
                        >
                            <Trans
                                i18nKey="home-description"
                                components={{
                                // eslint-disable-next-line jsx-a11y/anchor-has-content
                                1: <a
                                    href="https://id.et/updatecenters"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-realnidgreen hover:underline"
                                    />
                                }}
                            />
                        </p>
                    </div>
                    <div className='bg-white'>
                        <div className='p-8 flex flex-col gap-2 text-MetallicBlue max-w-[400px] mx-auto'>
                            <p className='text-2xl font-semibold'>
                                {t("otp-text")}
                            </p>

                            <div className='flex items-center justify-center gap-1 flex-col'>
                                <OtpInput
                                    value={otp}
                                    onChange={setOtp}
                                    numInputs={6}
                                    shouldAutoFocus={true}
                                    inputType='tel'
                                    inputStyle={{
                                        borderRadius: "0.5rem",
                                        width: "2.7rem",
                                        height: "2.7rem",
                                        textAlign: "center",
                                        color: "black",
                                        borderColor: "black",
                                        borderWidth: "2px",
                                        borderStyle: "solid",
                                    }}
                                    renderSeparator={
                                        <span className='px-2'></span>
                                    }
                                    renderInput={(props) => (
                                        <input
                                            className=' text-MetallicBlue border border-MetallicBlue'
                                            {...props}
                                        />
                                    )}
                                />
                            </div>

                            <button
                                type='submit'
                                disabled={isLoading}
                                className='px-10 py-2 rounded-lg bg-[#FFB400] border border-MetallicBlue'
                            >
                                {isLoading ? (
                                    <div className='flex items-center gap-2 justify-center'>
                                        <Loader className='animate-spin' />
                                        {t("otp-button-verifying")}
                                    </div>
                                ) : (
                                    t("otp-button-verify")
                                )}
                            </button>

                            {isResponseError?.message === "invalid otp" ? (
                                <div className='text-red-500 flex justify-center mt-2'>
                                    {isResponseError?.message && (
                                        <p>{t("otp-error-text1")}</p>
                                    )}
                                </div>
                            ) : (
                                <div className='text-red-500 flex justify-center mt-2'>
                                    {isResponseError?.message && (
                                        <p>{t("otp-error-text2")}</p>
                                    )}
                                </div>
                            )}
                            <div className='flex items-center justify-center gap-1'>
                                <p className='w-fit'>{t("otp-resend-text")}</p>{" "}
                                <button
                                    className={` ${
                                        resendTime
                                            ? ""
                                            : "hover:underline focus:outline-none"
                                    } text-sm text-nidblue`}
                                    onClick={() => {
                                        handleResend();
                                    }}
                                    disabled={resendTime}
                                >
                                    {resendTime
                                        ? `${t(
                                              "otp-resend-text2"
                                          )} ${remainingTime} ${t(
                                              "otp-resend-text3"
                                          )}`
                                        : t("otp-resend-text1")}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Footer />
        </div>
    );
};

export default OTPInput;
